import styled from "@emotion/styled";
import { theme } from "../../../utils/Theme";

export const Container = styled.div``;

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
